import React, {Component, Fragment} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Footer from "../footer";
import PreviewEvents from "../Preview/PreviewEvents";
import Hero2 from "../theme/components/hero2";
import PreviewCaisse from "../Preview/PreviewCaisse";
import Hero from "../theme/components/hero";
import PreviewHoraires from "../Preview/PreviewHoraires";
import WebEditorRender from "../../../components/WebEditor";
import Loader from "../loader";

export default class Home extends Component{
    render(){
        const context=this.props.context
        const {org,config}=context
        const description=org.name

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={org.name} description={description}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <Fragment>
                <Meta context={context} title={org.name} description={description}/>

                <Header context={context} isHome/>

                <div dir={"ltr"}>
                    {Array.isArray(config["hero.carousel"]) && config["hero.carousel"].length>0 &&(
                        <Hero2 context={context}/>
                    )}

                    {(!config["hero.carousel"] || !Array.isArray(config["hero.carousel"]) || config["hero.carousel"].length===0) &&(
                        <Hero context={context}/>
                    )}
                </div>


                <PreviewHoraires context={context}/>

                <PreviewEvents context={context}/>

                {config["home.sections.disable.don"]!==true &&(
                    <PreviewCaisse context={context}/>
                )}


                {org.mainPage &&(
                    <div>
                        <WebEditorRender page={org.mainPage} lang={context.lang?.value || "fr"}/>
                    </div>
                )}


                <Footer context={context} />

            </Fragment>
        )
    }
}
